import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';
import api from '../services/api';

export const TableContext = createContext();

export const TableProvider = ({ children }) => {
  TableProvider.propTypes = {
    children: PropTypes.node.isRequired
  };
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState(null);
  const [loading, setLoading] = useState(false); // Start with false to avoid immediate loading

  const fetchTables = async () => {
    try {
      setLoading(true);
      const response = await api.get('/tables');
      setTables(response.data);
    } catch (error) {
      console.error('Error fetching tables:', error);
      // Set empty tables on error instead of leaving loading state
      setTables([]);
    } finally {
      setLoading(false);
    }
  };

  const createTable = async (tableData) => {
    try {
      const response = await api.post('/tables', tableData);
      setTables([...tables, response.data]);
      return response.data;
    } catch (error) {
      console.error('Error creating table:', error);
      throw error;
    }
  };

  const updateTable = async (tableId, tableData) => {
    try {
      const response = await api.put(`/tables/${tableId}`, tableData);
      setTables(tables.map(table => 
        table.id === tableId ? response.data : table
      ));
      return response.data;
    } catch (error) {
      console.error('Error updating table:', error);
      throw error;
    }
  };

  const deleteTable = async (tableId) => {
    try {
      await api.delete(`/tables/${tableId}`);
      setTables(tables.filter(table => table.id !== tableId));
    } catch (error) {
      console.error('Error deleting table:', error);
      throw error;
    }
  };

  // Don't automatically fetch tables on mount - let components call fetchTables when needed
  // useEffect(() => {
  //   fetchTables();
  // }, []);

  return (
    <TableContext.Provider 
      value={{
        tables,
        selectedTable,
        loading,
        fetchTables,
        createTable,
        updateTable,
        deleteTable,
        setSelectedTable
      }}
    >
      {children}
    </TableContext.Provider>
  );
};
